import { asyncRoutes, router as constantRoutes } from '@/router/router';
import supervisionRoutes from '@/router/supervision';
import Fetch from '@/api/index';
import store from '@/store/index';
import { getRoleType, hasPermission as hasPre } from '@/util';
import Constant, { CHAIN_TYPE } from '@/lib/constant';

function filterAsyncRoutes(routes, roles) {
  let redirect = false;
  // 根据全选过滤不需要的路由
  const handlerRoutes = (routes, level = 1) => {
    return routes.reduce((total, route) => {
      const tmp = { ...route };
      if (hasPermission(roles, tmp)) {
        if (!redirect && level === 1 && route.meta && !route.meta.hide) {
          total.push({ path: '', redirect: route.path });
          total.push({ path: '/', redirect: route.path });
          redirect = true;
        }
        if (tmp.children) {
          tmp.children = handlerRoutes(tmp.children, level + 1);
        }
        total.push(tmp);
      }
      return total;
    }, []);
  };
  return handlerRoutes(routes);
}

function filterSupervisionRoutes(menuList) {
  const iconMap = {
    进销存管理: 'icon-tubiao-dingdanguanli',
    处方药品管理: 'icon-tubiao-chufangyaopinguanli',
    四类药品管理: 'icon-tubiao-sileiyaopin',
    特殊药品管理: 'icon-tubiao-teshuyaopin',
    执业药师列表: 'icon-tubiao-zhiyeyaoshi'
  };
  menuList.map(item => {
    item.icon = iconMap[item.title];
  });
  return menuList;
}

function hasPermission(roles, route) {
  // 负责路由是否匹配
  // 检测是否匹配

  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
}
function genRole(res) {
  let { roleList } = res;
  return roleList.map(v => {
    return v.code;
  });
}
const state = {
  isSupervision: false, // 是否为药监 默认选否
  routes: [],
  sr: [],
  addRoutes: [],
  roles: [],
  userInfo: '',
  roleType: '',
  supervisionConfig: {},
  supervisionCenterInfo: {},
  funcRights: [{ bizKey: 'drugstore:remoteBatchAudit:blackList', checkResult: true }]
};
const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  SET_SR_ROUTES: (state, routes) => {
    state.sr = routes;
  },
  SET_SUPERVISION_STATUS: (state, status) => {
    state.isSupervision = status;
  },
  SET_ROLES: (st, roles) => {
    st.roles = roles;
  },
  SET_ROLE_TYPE: (st, roleList) => {
    let roleType = getRoleType(roleList);
    st.roleType = roleType;
  },
  SET_SUPERVISION_CONFIG: (state, config) => {
    state.supervisionConfig = config;
  },
  SET_SUPERVISION_CENTER_INFO: (state, config) => {
    state.supervisionCenterInfo = config;
  },
  setFuncRights: (state, rights) => {
    state.funcRights = rights;
  }
};

const actions = {
  GenerateRoutes(
    { commit, dispatch, rootState },
    {
      roles,
      userInfo: { isSupportPcApplyPrescription, punchOn, enterpriseOfficialAccount },
      drugShopEntrance,
      supervisionConfig
    }
  ) {
    // 生成动态路由
    return new Promise(resolve => {
      let accessedRoutes = asyncRoutes || [];
      let srRouter = [];
      if (!roles.includes('admin')) {
        // 判断是否有申请处方菜单
        const { allowsimpleConsult, allowVideoConsult } = this.getters['global/allowedConsultTypes'];
        if (!allowsimpleConsult && !allowVideoConsult) {
          accessedRoutes = accessedRoutes.filter(
            router => !/^(applyPrescription|chooseConsultType)$/.test(router.name)
          );
        }

        // punchOn = 1;
        // 判断是否开启上下班打卡权限
        if (!punchOn) {
          accessedRoutes = accessedRoutes.filter(router => !/^punch$/.test(router.name));
        } else {
          // 远程药师获取打卡状态
          if (roles.includes(Constant.RoleList.b)) {
            dispatch('global/SETpunchState', null, { root: true });
          }
        }

        // 判断是否要展示[企业微信]菜单
        if (!enterpriseOfficialAccount) {
          accessedRoutes = accessedRoutes.filter(router => !/^enterpriseWeChat$/.test(router.name));
        }

        // 是否显示b2b入口
        if (!drugShopEntrance) {
          accessedRoutes = accessedRoutes.filter(router => !/^b2b$/.test(router.name));
        }
        // 路由权限判断
        accessedRoutes = filterAsyncRoutes(accessedRoutes, roles);
      }
      commit('SET_ROUTES', accessedRoutes); // 设置药店路由

      resolve(accessedRoutes);
    });
  },
  async getInfo({ commit, rootState }, data) {
    // 第一次进入时需要去获取用户权限
    let res = null;
    if (rootState.global.userInfo && !data?.refresh) {
      res = rootState.global.userInfo;
    }

    try {
      // 解决Unhandled promise rejection;undefined;
      if (!res) {
        res = await Fetch.getUserAndStoreInfo();
        // const store = res?.storeList[0];
        // try {
        //   const rights = await Fetch.whiteListBizCheck({
        //     bizKeyList: ['drugstore:remoteBatchAudit:blackList'],
        //     storeId: store.id
        //   });
        //   commit('setFuncRights', rights || []);
        // } catch (err) {
        //   console.log(err);
        // }
      }
      setTimeout(() => {
        setTracker(res);
      }, 1000);
    } catch (error) {
      console.log(error);
    }
    store.commit('global/SETINFO', res);
    let roles = genRole(res);
    let { roleList } = res;
    return new Promise(resolve => {
      resolve({ roles, userInfo: res });
      commit('SET_ROLES', roles);
      commit('SET_ROLE_TYPE', roleList);
    });
  }
};

function setTracker({ userId, roleList, storeList }) {
  let userType = null;
  try {
    const { type, isExpire } = storeList[0];
    userType = isExpire ? '过期' : { 1: '年费', 2: '储值', 3: '试用', 4: '普通' }[type];
  } catch (error) {}
  Telescope.trackEvent({
    trackId: 'zywzpc-click-login',
    custom: {
      userId,
      roles: roleList.map(({ code }) => code).join(),
      userType
    }
  });
}

// 删除服务套餐页面
function deleteServicePackagePage(routes) {
  routes = routes.filter(router => !/^servicePackage$/.test(router.name));
  if (hasPre([Constant.RoleList.a]) && !hasPre([Constant.RoleList.d])) {
    routes = routes.filter(router => !/^shopAccount$/.test(router.name));
  }
  return routes;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
